import SubtitleLocalization from './SubtitleLocalization.vue';

export default {
  SubtitleLocalization,
};
